import { CSSObject } from '@emotion/react';
import { createResponsiveStyles, HoneycombTheme, SpacingValue, useHoneycombTheme } from '../../../theming';
import { useCard } from '../Card.context';

function getPaddingStyles(theme: HoneycombTheme) {
    return (padding: SpacingValue): CSSObject => {
        const paddingValue = theme.fn.getSpacingValue(padding);
        return {
            paddingLeft: paddingValue,
            paddingRight: paddingValue,
        };
    };
}

type StyleClasses = 'root' | 'content' | 'icon';

export function useStyles(): {
    styles: { [key in StyleClasses]: CSSObject };
} {
    const { theme } = useHoneycombTheme();
    const { Card: cardTheme } = theme.components.themes;

    const { padding } = useCard();

    const root: CSSObject = {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        paddingTop: `${cardTheme.paddingY}px`,
        paddingBottom: `${cardTheme.paddingY}px`,
        backgroundColor: theme.fn.resolveColorValue(cardTheme.selectedBorderColor),
        color: theme.fn.resolveColorValue(cardTheme.textColor),

        ...createResponsiveStyles(
            [
                {
                    value: padding,
                    getStyles: getPaddingStyles(theme),
                },
            ],
            theme
        ),
    };

    const content: CSSObject = {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        flex: '1 0 0',
    };

    const icon: CSSObject = {
        color: theme.fn.resolveColorValue(cardTheme.iconColor),
    };

    return {
        styles: {
            root,
            content,
            icon,
        },
    };
}
